import ImageCapture from "./ImageCapture";

export default ImageCapture;
